import React from "react";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

interface MobilePhlebotomySupportButtonProps {
  onRequest: () => void;
}

const MobilePhlebotomySupportButton: React.FC<
  MobilePhlebotomySupportButtonProps
> = ({ onRequest }) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="unity-outline-orange"
      startIcon={<SupportAgentOutlinedIcon />}
      onClick={onRequest}
      sx={{ borderRadius: 999, minHeight: 45, px: 3, fontWeight: 700 }}
    >
      {t("phlebotomySearch.mobileOptions.whiteGloveAction")}
    </Button>
  );
};

export default MobilePhlebotomySupportButton;
